import control from './controls/control';
import constants from './constants';

const getExtension = () => ({
  slug: constants.common.slug,
  title: 'WS Footer Navigation Settings',
  description: 'Extension for editing footer navigation links',
  settings: {
    querySelector: "[slot='footer-navigation'] > ul",
  },
  ui: {
    control: [control],
  },
});

export default getExtension;
